import React from 'react'

const ParagraphText = ({className, children, title, ...rest}) => {
  return (
    <p className={`p-0 m-0 ${className}`} title={title} {...rest}>
        {children}
    </p>
  )
}

export default ParagraphText
